<template>
	<div class='custom-modal' v-if='isOpen' :class='{ "custom-modal--open": isOpen }'>
		
		<div class='custom-modal__background' @click='close'>
			<button class='custom-modal__close-btn'><i class='fa fa-times'></i></button>
		</div>

		<img class='image' v-if='url' ref='image' :src='url'>

	</div>
</template>

<script>
	export default {
		name: 'CustomModal',
		props: {
			title: {
				type: String,
				default: '',
			},

			url: {
				type: null,
				default: null,
			}
		},
		data() {
			return {
				isOpen: false
			};
		},
		methods: {
			open() {
				this.isOpen = true;

			},
			close() {
				this.isOpen = false;
			}
		}

	};
</script>

<style scoped>
	.custom-modal {
		height: 100vh;
		width: 100vw;

		position: absolute;
		top: 0;
		left: 0;

		z-index: 100;
	}

	.custom-modal__background {
		height: 100%;
		width: 100%;

		background-color: rgba(0, 0, 0, 0.9);
		transition: all 1s ease;
	}

	.custom-modal__window {
		background-color: #fff;

		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		height: 90%;
		width: 90%;
		min-width: 800px;
		max-width: 1400px;

		padding: 10px 0;
	}

	/*.custom-modal__window-wrapper {
		padding: 20px;
		height: 100%;
	}*/

	.custom-modal__header {
		height: 2rem;
	}

	.custom-modal__body {
		overflow-y: auto;
		/*overflow-y: hidden;*/
		height: calc(100% - 2rem);
		/*margin: 0 10px;*/
		padding: 0 10px;
	}

	.custom-modal__title {
		font-size: 20px;
	}

	.custom-modal__close-btn {
		cursor: pointer;
		position: absolute;
		right: 0;
		top: 0;

		border: none;
		color: gray;
		background-color: transparent;
		font-size: 40px;
		outline: none;

		font-size: 20px;

		transition: 0.2s all ease;
	}

	.custom-modal__close-btn:hover {
		/*font-size: 24px;*/
		color: gray;
	}

	.image {
		position: absolute;
		top: 50%;
		left: 50%;

		max-height: 90vh;

		transform: translate(-50%, -50%);
	}

</style>